import React from 'react'
import { Link } from 'react-router-dom'
import AppSecondaryBtn from '../../components/ui/AppSecondaryBtn/AppSecondaryBtn'
import AppWrapper from '../../components/ui/AppWrapper/AppWrapper'
import AppPrimaryBtn from '../../components/ui/AppPrimaryBtn/AppPrimaryBtn'
import styles from './FailedView.module.css'

const FailedView: React.FC = () => {
  return (
    <AppWrapper className="bg-appLightGray h-[80%]">
      <div className={styles.errorCircleWrapper}>
        <i className="fas fa-times-circle text-[#BB0000]"></i>
      </div>
      <div className={styles.errorWrapper}>
        <div className={styles.title}>Произошла ошибка.</div>
        <div className={styles.description}>Детальное описание ошибки из платежного шлюза</div>
      </div>

      <div className={styles.actions}>
        <AppSecondaryBtn className="w-full"> Выбрать другой метод оплаты </AppSecondaryBtn>
        <Link to="/home">
          <AppPrimaryBtn className="w-full">
            <span className="uppercase">Вернуться на главную</span>
          </AppPrimaryBtn>
        </Link>
      </div>
    </AppWrapper>
  )
}

export default FailedView
